import { render } from "./CommunicationItem.vue?vue&type=template&id=3fab1fbc&scoped=true"
import script from "./CommunicationItem.vue?vue&type=script&lang=js"
export * from "./CommunicationItem.vue?vue&type=script&lang=js"

import "./CommunicationItem.vue?vue&type=style&index=0&id=3fab1fbc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fab1fbc"]])

export default __exports__